import React, { useEffect, useState } from 'react'
import DynamicForm from '../../../../components/FormElements/DynamicForm'
import Button from '../../../../components/FormElements/Button';
import CarRegCustomSelectBox from '../../../../components/BookingFormComponents/CarRegCustomSelectBox';
import LocationPicker from '../../../../components/LocationPicker';
import ServicesCustomSelectBox from '../../../../components/BookingFormComponents/servicesCustomSelectBox/index';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { setAppLoading, setError, setMessage } from '../../../../store/common/generalSlice';
import useBookingApi from '../../../../config/hooks/api/booking/useBookingApi';
import { filtersDataFormatter } from '../../../../config/utils/FiltersDataFormatter';
import CarDetailBox from '../../../../components/BookingFormComponents/CarDetailBox';

const AddBooking = ({ onSuccess }) => {
    const dispatch = useDispatch()
    const { createPersonalBooking, getServiceProviderSelectedServices } = useBookingApi()

    const { loggedInUser } = useSelector(state => state.auth);

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const [servicesCustomError, setServicesCustomError] = useState(false);
    const [fetchedVehicleData, setFetchedVehicleData] = useState(null)
    const [spServicesData, setSpServicesData] = useState([])
    const [formUpdatedFields, setFormUpdatedFields] = useState(null);

    const handleFetchedCarData = (data) => {
        if (data) {
            setFetchedVehicleData(data?.data?.newVehicle);
            setFormUpdatedFields(data?.data?.newVehicle); 
        }
    }

    // a function to get the serviceProvider detail
    const getServiceProviderDetail = async () => {
        const response = await getServiceProviderSelectedServices(loggedInUser?.id);
        if (response) {
            if (response?.data?.serviceProviderServices?.length > 0) {
                const data = filtersDataFormatter(response?.data?.serviceProviderServices);
                setSpServicesData(data);
            }
        }
    }

    useEffect(() => {
        if (loggedInUser?.id) {
            const fetchData = async () => {
                try {
                    await getServiceProviderDetail()
                } catch (error) {
                    dispatch(setError('An error occured'))
                }
            }
            fetchData()
        }
    }, [loggedInUser])

    const form = {
        name: 'addBooking',
        formFields: [
            {
                name: 'email',
                label: { value: "User's Email address:", classes: '' },
                type: 'email',
                placeholder: 'john@gmail.com',
                width: { md: 12, sm: 12, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
            {
                name: 'carRegNo',
                label: { value: 'Vehicle Registration Number:', classes: '' },
                type: 'custom',
                placeholder: '',
                width: { md: 12, sm: 12, xs: 24 },
                component: <CarRegCustomSelectBox myCar={(data) => handleFetchedCarData(data)} />,
                classes: '',
                icon: null
            },
            {
                name: 'carDetails',
                type: 'custom',
                label: '',
                width: { md: formUpdatedFields ? 24 : 0, sm: formUpdatedFields ? 24 : 0, xs: formUpdatedFields ? 24 : 0 },
                component: formUpdatedFields && <div className='mb-4'><CarDetailBox carDetails={formUpdatedFields} bg={'white'} /></div>,
                classes: '',
                icon: null,
            },
            {
                name: 'services',
                label: { value: 'Services:', classes: '' },
                type: 'custom',
                placeholder: '',
                width: { md: 12, sm: 12, xs: 24 },
                component: <ServicesCustomSelectBox
                    classes='shadow-md border'
                    servicesCustomError={servicesCustomError}
                    setServicesCustomError={setServicesCustomError}
                    spServicesData={spServicesData}
                />,
                classes: '',
                icon: null
            },
            {
                name: 'details',
                label: { value: 'Any Addtional Info/Note:', classes: '' },
                type: 'text',
                placeholder: 'Any Addtional Info/Note',
                width: { md: 12, sm: 12, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
            {
                name: 'price',
                label: { value: 'Enter Price:', classes: '' },
                type: 'text',
                placeholder: '£50.40',
                width: { md: 12, sm: 12, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
            {
                name: 'date',
                label: { value: 'Date:', classes: '' },
                type: 'datepicker',
                placeholder: '10 June, 2024',
                width: { md: 6, sm: 6, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
            {
                name: 'time',
                label: { value: 'Time:', classes: '' },
                type: 'timepicker',
                placeholder: '12:18PM',
                width: { md: 6, sm: 6, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
            {
                name: 'location',
                label: { value: 'Location:', classes: '' },
                type: 'custom',
                placeholder: '4058 Little York Rd, Houston',
                width: { md: 24, sm: 24, xs: 24 },
                component: <LocationPicker />,
                classes: '',
                icon: null
            },
            {
                name: 'additionalService',
                label: { value: 'Any Addtional Service:', classes: '' },
                type: 'textarea',
                placeholder: 'Any Addtional Service',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
        ],
        formValidation: {
            email: Yup.string()
                .required('Email is required')
                .email('Email is invalid')
                .test('max-domain-length', 'The domain part of the email should not exceed 90 characters', (value) => {
                    if (!value) return true; // Skip validation if the email is empty (handled by required above)
                    const domainPart = value.split('@')[1];
                    return domainPart && domainPart.length <= 100;
                })
                .matches(
                    emailRegex,
                    'Invalid email format. Only dashes (-) and dots (.) are allowed as special characters.'
                ),
            carRegNo: Yup.string()
                .test('is-required', 'No is required', function (value) {
                    return !!value; // Ensure the value exists (non-empty)
                })
                .test(
                    'conditional-validation',
                    'Input must be exactly 7 characters and follow the pattern',
                    function (value) {
                        if (!value) {
                            return true; // Skip length and pattern validation if the field is empty
                        }
                        if (value.startsWith('aaa') || value.startsWith('AAA')) {
                            return true; // No pattern or length validation if it starts with 'aaa' or 'AAA'
                        }
                        const ukCarRegPattern = /^[A-Z]{2}[0-9]{2}[A-Z]{3}$/i; // Case-insensitive pattern for UK car registration
                        return value.length === 7 && ukCarRegPattern.test(value); // Validate length and pattern
                    }
                ),
            // Price field must be a number, non-negative, and required
            price: Yup.number()
                .required('Price is required')
                .typeError('Price must be a number')
                .min(0, 'Price cannot be negative'),
            services: Yup.array()
                .of(
                    Yup.mixed()
                        .test('is-valid-id', 'ID must be a number or a string', (value) =>
                            typeof value === 'number' || typeof value === 'string'
                        )
                        .required('ID is required')
                )
                .min(1, 'At least one service should be selected'),
            // services: Yup.object().shape({
            //     'Category 1': Yup.array(),
            //     'Category 2': Yup.array(),
            //     'Category 3': Yup.array(),
            //     }).test('at-least-one-category', 'At least one category must have an item', (value) => {
            //     // Ensure the object exists before checking arrays
            //     if (!value) return false;

            //     // Check if at least one of the categories has at least one element
            //     return (
            //         (value['Category 1'] && value['Category 1'].length > 0) ||
            //         (value['Category 2'] && value['Category 2'].length > 0) ||
            //         (value['Category 3'] && value['Category 3'].length > 0)
            //     );
            // }),

            addtionalServices: Yup.string()
                .max(500, 'You cannot enter more than 500 characters'),

            location: Yup.object()
                .shape({
                    lat: Yup.number()
                        .required('Latitude is required')
                        .min(-90, 'Latitude must be greater than or equal to -90')
                        .max(90, 'Latitude must be less than or equal to 90'),
                    lng: Yup.number()
                        .required('Longitude is required')
                        .min(-180, 'Longitude must be greater than or equal to -180')
                        .max(180, 'Longitude must be less than or equal to 180'),
                })
                .required('Location is required') // Ensures the location object exists
                .test('hasKeys', 'Location is required', value =>
                    value && 'lat' in value && 'lng' in value
                ),
        }
    }

    const handleSubmit = async (values) => {
        try {
            const data = { ...values }
            const { lat: latitude, lng: longitude, address } = values?.location
            const date = dayjs(data.date);
            const formattedDate = date.format('YYYY-MM-DD');
            const formattedTime = dayjs(data?.time).format('HH:mm');

            delete data?.location
            // payload.services = [].concat(...Object.values(temp?.services))
            // payload.services = [18,19,20] //dev env
            // payload.services = [77,80,83] //qa env

            const vehicleData = { ...fetchedVehicleData }

            delete data?.carDetails
            delete data?.carRegNo
            delete vehicleData?.id
            delete vehicleData?.createdAt
            delete vehicleData?.isApproved
            delete vehicleData?.updatedAt
            delete vehicleData?.userId
            delete vehicleData?.year
            delete vehicleData?.vehicleRegistrationNumber

            dispatch(setAppLoading(true))

            const response = await createPersonalBooking({
                ...data,
                ...vehicleData,
                date: formattedDate,
                time: formattedTime,
                // services: [18,19,20],
                vehicleRegistrationNo: fetchedVehicleData?.vehicleRegistrationNumber,
                year: fetchedVehicleData?.year + '',
                latitude,
                longitude,
                address,
                quote: false
            })

            if (response) {
                onSuccess()
                dispatch(setAppLoading(false))
                dispatch(setMessage(response?.data?.message))
                setFormUpdatedFields(null)
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    };

    const submitForm = () => {
        document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    return (
        <div className='p-4 text-center w-full'>
            <h6 className='heading-6 font-bold mb-4'>Add a Booking</h6>
            <DynamicForm form={form} onSubmit={handleSubmit} />
            <div className="flex justify-end w-full">
                <Button.Basic
                    onClick={submitForm}
                    disabled={false}
                    icon={null}
                    loading={false}
                    type="primary"
                    size='medium'
                    text='Submit'
                    className='btn-primary md:w-fit sm:w-fit w-full'
                />
            </div>
        </div>
    )
}

export default AddBooking

